import React, { Fragment } from 'react';
import { usePqDataManager } from '../../providers/PqDataManagerProvider';
import { transformHTMLParserLinks } from '../../../../utils/rewriteLink/rewriteLink';
import iconCheckPath from '../../../../assets/images/icon-utility-check-mark.svg';
import { Row, Col } from '../../../../importCL';

export default function Benefits() {

    const {
        pqMappingContent: { bulletsAndIcons, textForBelowTheCardImageMF, cardArtImagePathMF, cardArtAltTextMF, enablePremiumCardDisclosure, premiumCardDisclosure },
    } = usePqDataManager();

    return (
        <Row as='section' className='Benefits'>
            {textForBelowTheCardImageMF && (
                <Col className='Benefits__message !pl-10' xs={{ span: 12, order: 2 }}>
                    <h2 className='text-xl font-light mb-2'>
                        {transformHTMLParserLinks(textForBelowTheCardImageMF)}
                    </h2>

                </Col>
            )}
            <Col className='Benefits__bullets !px-8' xs={{ span: 12, order: 3 }}>
                {bulletsAndIcons &&
                    <div className='mt-12'>
                        {bulletsAndIcons.map(({ keyValues1_bulletTitle: title, keyValues1_bulletText: message }, index) => {
                            return index >= 2
                                ? <></> 
                                : (
                                    <Fragment key={index}>
                                        <div className='flex items-start m-3'>
                                            <img className='pr-8 mt-4' src={iconCheckPath} alt='Check Mark Icon' />
                                            <div>
                                                <h4 className='font-bold text-2xl !leading-2r m-0'>{transformHTMLParserLinks(title)}</h4>
                                                <p>{transformHTMLParserLinks(message)}</p>
                                            </div>
                                        </div>
                                    </Fragment>
                                );
                        },
                        )}
                    </div>
                }
            </Col>
            <Col className='Benefits__card md:!px-0' 
                xs={{ span: 12, order: 1 }} 
            >
                {cardArtImagePathMF && cardArtAltTextMF && (
                    <div className={'Benefits__cardContainer'}>                        
                        <img fetchpriority='high' src={cardArtImagePathMF} alt={cardArtAltTextMF} />
                        {premiumCardDisclosure && enablePremiumCardDisclosure && (
                            <div>
                                <p className='m-0'>{transformHTMLParserLinks(premiumCardDisclosure)}</p>
                            </div>
                        )} 
                    </div>
                )}
            </Col>
        </Row>
    );
}